import { Button, Grid, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import agentStyle from '../../Styles/ComponentStyles/Agent.module.scss'
import GlobalTextfield from '../GlobalTextfield/GlobalTextfield'
import globalStyles from '../../Styles/ComponentStyles/global.module.scss'

const RegisterAgent = (props: any) => {
    const { setFlagOpenAgentDetailsDialog, handleSubmit, isEditMode, agentFormDetails, setagentFormDetails } = props

    const [isButtonEnabled, setIsButtonEnabled] = useState<any>(false)
    const handleFormSubmit = () => {
        handleSubmit(agentFormDetails);
    };
    const emailRegex = /^([a-zA-Z0-9._]+)@([a-zA-Z0-9-]+)\.([a-zA-Z]{2,})(\.[a-zA-Z]{2,})?$/;
    const contactNumberRegex = /^\d+$/;

    useEffect(() => {
        const { first_name, last_name, email_address, contact_number } = agentFormDetails;
        const isValid = first_name && first_name?.trim() !== '' &&
            last_name && last_name?.trim() !== '' &&
            email_address && emailRegex.test(email_address) &&
            contact_number && contactNumberRegex.test(contact_number);;
        setIsButtonEnabled(isValid);
    }, [agentFormDetails]);

    return (
        <Grid container gap={5}>
            <Grid item xs={12} sx={{ padding: "20px" }}>
                <Grid container>
                    <Grid item xs={12}>
                        <Grid container justifyContent={"center"} gap={3}>
                            <Grid item xs={12}>
                                <Grid container gap={1}>
                                    <Grid item xs={12}>
                                        <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                            First Name <span style={{ color: 'red' }}>*</span>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <GlobalTextfield
                                            required
                                            id="first-name"
                                            variant="outlined"
                                            placeholder='Enter First Name'
                                            fullWidth
                                            stylingClassName={`${globalStyles.globalPFTextfield}`}
                                            value={agentFormDetails?.first_name}
                                            onChange={(event: any) => {
                                                setagentFormDetails({
                                                    ...agentFormDetails,
                                                    first_name: event.target.value
                                                })
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container gap={1}>
                                    <Grid item xs={12}>
                                        <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                            Last Name <span style={{ color: 'red' }}>*</span>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <GlobalTextfield
                                            required
                                            id="last-name"
                                            variant="outlined"
                                            placeholder='Enter Last Name'
                                            fullWidth
                                            stylingClassName={`${globalStyles.globalPFTextfield}`}
                                            value={agentFormDetails?.last_name}
                                            onChange={(event: any) => {
                                                setagentFormDetails({
                                                    ...agentFormDetails,
                                                    last_name: event.target.value
                                                })
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container gap={1}>
                                    <Grid item xs={12}>
                                        <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                            Email <span style={{ color: 'red' }}>*</span>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <GlobalTextfield
                                            required
                                            id="email"
                                            variant="outlined"
                                            placeholder='Enter Email'
                                            fullWidth
                                            disabled={isEditMode}
                                            stylingClassName={`${globalStyles.globalPFTextfield}`}
                                            value={agentFormDetails?.email_address}
                                            onChange={(event: any) => {
                                                setagentFormDetails({
                                                    ...agentFormDetails,
                                                    email_address: event.target.value
                                                })
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container gap={1}>
                                    <Grid item xs={12}>
                                        <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                            Phone <span style={{ color: 'red' }}>*</span>
                                        </Typography>
                                    </Grid>
                                    <GlobalTextfield
                                        required
                                        id="phone"
                                        variant="outlined"
                                        placeholder='Enter Phone'
                                        fullWidth
                                        stylingClassName={`${globalStyles.globalPFTextfield}`}
                                        value={agentFormDetails.contact_number}
                                        onChange={(event: any) => {
                                            const value = event.target.value;
                                            if (contactNumberRegex.test(value) || value === '') {
                                                setagentFormDetails({
                                                    ...agentFormDetails,
                                                    contact_number: value
                                                });
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sx={{ margin: "40px 0px 0px" }}>
                        <Grid container sx={{ justifyContent: 'center', gap: '20px' }} alignItems={"center"}>
                            <Grid item>
                                <Button
                                    variant="outlined"
                                    className={agentStyle.buttonCancel}
                                    onClick={() => {
                                        setFlagOpenAgentDetailsDialog(false)
                                        setagentFormDetails({})
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    className={agentStyle.buttonSubmit}
                                    onClick={handleFormSubmit}
                                    disabled={!isButtonEnabled}
                                >
                                    {isEditMode ? "Save" : "Register"}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

        </Grid >
    )
}

export default RegisterAgent
